var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"down-arrow 2","clipPath":"url(#clip0_893_2570)","key":0},React.createElement("path",{"id":"XMLID_225_","d":"M13.6696 17.7604C13.989 17.4409 13.9891 16.9228 13.6695 16.6033L6.06625 9.00019L13.6696 1.39672C13.989 1.07725 13.9891 0.559173 13.6695 0.239645C13.35 -0.0798818 12.832 -0.0798819 12.5124 0.239645L4.33061 8.42168C4.17718 8.57512 4.091 8.78321 4.091 9.00019C4.091 9.21717 4.17723 9.42532 4.33067 9.5787L12.5125 17.7603C12.832 18.0799 13.35 18.0799 13.6696 17.7604Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_893_2570"},React.createElement("rect",{"width":"18","height":"18","fill":"white","transform":"translate(18) rotate(90)"})))]);
}

LeftArrow.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
